//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch, mergeMap, catchError, switchMap, map } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf, throwError } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const token = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiQXBwIiwiZmFtaWx5X25hbWUiOiJDbGllbnQiLCJlbWFpbCI6ImFwcGNsaWVudEBibHVlYXNzaXN0LmJpeiIsImlkIjoiY2MyZmViZjMtYTAwMi00OGIxLWE0MTctNmVkNTlmZmI2MTJiIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQXBwIiwiZXhwIjoxNzQyODE5MDkzLCJpc3MiOiJCQUNGaW5hbmNpYWwiLCJhdWQiOiJCQUNGaW5hbmNpYWxVc2VycyJ9.M_XBWck0Q2Dcc6dl9xQHMUeJMwuQ4IMWGcHTBWY25ts";
export const Cookie = ".AspNetCore.Identity.Application=CfDJ8CTLpubzZI5KjBM7PR9npgARhalTlkUOcMdhoboi8MBc76b72U8uAmo9riZCoLxe5gH6beT0_yuwTsVN274vp_MBd1lUfi6AxOhdK_Wgjx1LRy_ZzYbDUQnIjsBprIhvh4oSiEMW9tMwkJpwPyIEz6sLI4IAwB4zuBP8iLClBNvqTB0jQyr9SkyZr8Mjwt3xlTTxPL9YCHqLKBCu48z7piFiHzrJeLO5FAgjDEDA8kVlC336wPehKxtaHjIl8pXBlFqvj5Sa3Vp2JyqVTZ6IQ3W0RJ3MVvj8BJwUnaR1vQCZkWF1x4IAagMjaN8wFZXCbBDPnAc27oeo4-4ygZiWSR-nM19DB5kkxnvP8e-iRiL-nWhN0lKXrJl4uMj9xGxLyL0llvn5l7AOrRWEAR8gDT2UJadG1VpUL-QaxTV8aWWqOHlTDIwwKFEDTwt0vI_u5riH5G3m0Tt5UEDZPxUCrP6iyux2MeCAR_2WygtBtz6gBQiyowaWVxzBVNSlHOXEnBxaDtGZkSamnkgDuf6jf_qatHnp9J0h_bDqEuV4rQ99n_7Qr5s5jK1qk5RdDZYGPW6ms3bmhKmlLPfJ1zp23ZmL-jtwOKW0ot4fhu47NiBKglOd_W7C5ZMFdPk1Xy33Zps-wIDlue6IYecR9xysyjDC3lHGa9144DeiYI_IbMd8MmKimW4cBoA9UP1va43_Y6bFRp85P4YRATTKLzzudTMkb4ZVS2Kaw2DinW5Ogw3qIYYfLwkbLB43pEzEPtqmGLbIGYNcYXm1SZ41LXcfU4w9ecc-aqm9YyMJfy-9vPUX_ECUk2NtaDOAt8AvlTrzyNQwyMImeEsxnbZTZvPBHTWhkwCTK-3sX7jtN_Y0lWJr; ARRAffinity=701402fd4c1d419de470fef5c052af6706cb11a8faa9d31bb90dc7a8773b697a; ARRAffinitySameSite=701402fd4c1d419de470fef5c052af6706cb11a8faa9d31bb90dc7a8773b697a";
export interface IDataClient {
    getCountries(): Observable<CountryModel[]>;
    getCountries2(regionId: number): Observable<CountryModel[]>;
    getRegions(): Observable<GeographicalRegionModel[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DataClient implements IDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCountries(): Observable<CountryModel[]> {
        let url_ = this.baseUrl + "/api/Data/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            withCredentials: true,
            crossDomain: true,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Authorization": token,
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryModel[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<CountryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CountryModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getCountries2(regionId: number): Observable<CountryModel[]> {
        let url_ = this.baseUrl + "/api/Data/countries/{regionId}";
        if (regionId === undefined || regionId === null)
            throw new Error("The parameter 'regionId' must be defined.");
        url_ = url_.replace("{regionId}", encodeURIComponent("" + regionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            withCredentials: true,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCountries2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CountryModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CountryModel[]>;
        }));
    }

    protected processGetCountries2(response: HttpResponseBase): Observable<CountryModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(CountryModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRegions(): Observable<GeographicalRegionModel[]> {
        let url_ = this.baseUrl + "/api/Data/regions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            withCredentials: true,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRegions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeographicalRegionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeographicalRegionModel[]>;
        }));
    }

    protected processGetRegions(response: HttpResponseBase): Observable<GeographicalRegionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(GeographicalRegionModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDocumentsClient {
    generateQuoteDocument(quoteId: string): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentsClient implements IDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    generateQuoteDocument(quoteId: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Documents/GenerateQuoteDocument/" + quoteId;
        url_ = url_.replace(/[?&]$/, "");


        let options_: any = {
            withCredentials: true,
            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateQuoteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateQuoteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateQuoteDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEmailClient {
    sendAgentInvitationEmail(request: AgentInvitationRequestModel): Observable<boolean>;
    sendQuoteByEmail(request: SendQuoteByEmailModel): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient implements IEmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sendAgentInvitationEmail(request: AgentInvitationRequestModel): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Email/sendAgentInvitationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            withCredentials: true,
            body: content_,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAgentInvitationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAgentInvitationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendAgentInvitationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendQuoteByEmail(request: SendQuoteByEmailModel): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Email/sendQuoteByEmail/" + request.quoteModel.number;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            withCredentials: true,
            body: content_,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendQuoteByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendQuoteByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendQuoteByEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPaymentClient {
    makeACardPayment(request: CardPaymentRequestModel): Observable<PaymentProcessorResponseModel>;
}

@Injectable({
    providedIn: 'root'
})
export class PaymentClient implements IPaymentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    makeACardPayment(request: CardPaymentRequestModel): Observable<PaymentProcessorResponseModel> {
        let url_ = this.baseUrl + "/api/Quotes/" + request.number + "/pay";
        url_ = url_.replace(/[?&]$/, "");


        const content_ = JSON.stringify({
            "payer": request.payer,
            "card": request.card
        });
        let options_: any = {
            withCredentials: true,
            body: content_,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMakeACardPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeACardPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentProcessorResponseModel>;
                }
            } else {
                // Forward any non-HttpResponse errors with best-effort parsing so UI can extract codes
                return _observableThrow(response_) as any as Observable<PaymentProcessorResponseModel>;
            }
        }));
    }

    protected processMakeACardPayment(response: HttpResponseBase): Observable<PaymentProcessorResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        // Treat typical success codes as success
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                // Some backends may return an empty body with a 2xx code
                const hasBody = _responseText !== undefined && _responseText !== null && _responseText !== "";
                if (hasBody) {
                    const resultData = JSON.parse(_responseText, this.jsonParseReviver);
                    const mapped = PaymentProcessorResponseModel.fromJS(resultData);
                    return _observableOf(mapped);
                }
                // Fallback: synthesize a basic success response when no body is returned
                return _observableOf(PaymentProcessorResponseModel.fromJS({ isSuccess: true }));
            }));
        } else if (status === 202 || status === 204) {
            // Accepted/No Content: consider as success for client flow
            return _observableOf(PaymentProcessorResponseModel.fromJS({ isSuccess: true }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status >= 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status >= 200 && status < 300) {
            // Any other 2xx response: attempt to parse, else return success
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                const hasBody = _responseText !== undefined && _responseText !== null && _responseText !== "";
                if (hasBody) {
                    const resultData = JSON.parse(_responseText, this.jsonParseReviver);
                    const mapped = PaymentProcessorResponseModel.fromJS(resultData);
                    return _observableOf(mapped);
                }
                return _observableOf(PaymentProcessorResponseModel.fromJS({ isSuccess: true }));
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
    }
}

export interface IQuoteClient {
    getRates(request: GetQuoteRatesRequestModel): Observable<GetQuoteResponseModel>;
    createPendingActivationCertificate(policyQuoteNumber: string): Observable<QuoteModel>;
}

@Injectable({
    providedIn: 'root'
})
export class QuoteClient implements IQuoteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getConfig(): Observable<ConfigurationModel> {
        let url_ = this.baseUrl + "/api/Plan/configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            withCredentials: true,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfigurationModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfigurationModel>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<ConfigurationModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let resultData200 = _responseText ? JSON.parse(_responseText, this.jsonParseReviver) : null;
                    if (resultData200) {
                        return _observableOf(ConfigurationModel.fromJS(resultData200));
                    }
                    return _observableOf(new ConfigurationModel()); // Return an empty object instead of null
                })
            );
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getQuote(id: string): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Quotes/${encodeURIComponent(id)}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };

        return this.http.request("get", url_, { ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                if (error_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateQuote(error_ as any);
                    } catch (e) {
                        return throwError(e) as any as Observable<QuoteModel>;
                    }
                } else {
                    return throwError(error_) as any as Observable<QuoteModel>;
                }
            })
        );
    }

    createQuote(quote: QuoteModel): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Quotes`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };
        const content_ = JSON.parse(JSON.stringify({ ...quote }));

        return this.http.request("post", url_, { body: content_, ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                // If it's an HTTP error response, let it pass through to the component
                if (error_ instanceof HttpResponseBase) {
                    return throwError(error_);
                } else {
                    return throwError(error_);
                }
            })
        );
    }

    updateQuote(quote: QuoteModel): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Quotes/${quote.number}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };
        quote.destinationRegionId = quote.destinationRegion.id
        quote.residenceCountryId = quote.destinationRegion.id
        const content_ = JSON.parse(JSON.stringify({ ...quote }));

        return this.http.request("put", url_, { body: content_, ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                // If it's an HTTP error response, let it pass through to the component
                if (error_ instanceof HttpResponseBase) {
                    return throwError(error_);
                } else {
                    return throwError(error_);
                }
            })
        );
    }

    getCertificate(quote: QuoteModel): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Certificates/pending-activation/${quote.certificateNumber}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };

        return this.http.request("get", url_, { ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                // If it's an HTTP error response, let it pass through to the component
                if (error_ instanceof HttpResponseBase) {
                    return throwError(error_);
                } else {
                    return throwError(error_);
                }
            })
        );
    }

    updateCertificate(quote: QuoteModel): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Certificates/pending-activation/${quote.certificateNumber}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };
        quote.destinationRegionId = quote.destinationRegion.id
        quote.residenceCountryId = quote.destinationRegion.id
        const content_ = JSON.parse(JSON.stringify({ ...quote }));

        return this.http.request("put", url_, { body: content_, ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                // If it's an HTTP error response, let it pass through to the component
                if (error_ instanceof HttpResponseBase) {
                    return throwError(error_);
                } else {
                    return throwError(error_);
                }
            })
        );
    }

    submitCertificate(quote: QuoteModel): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Certificates/pending-activation/${quote.certificateNumber}/activate`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };
        quote.destinationRegionId = quote.destinationRegion.id
        quote.residenceCountryId = quote.destinationRegion.id
        const content_ = JSON.parse(JSON.stringify({ ...quote }));

        return this.http.request("post", url_, { body: content_, ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                // If it's an HTTP error response, let it pass through to the component
                if (error_ instanceof HttpResponseBase) {
                    return throwError(error_);
                } else {
                    return throwError(error_);
                }
            })
        );
    }


    protected processCreateQuote(response: HttpResponseBase): Observable<GetQuoteResponseModel> {
        const status = response.status;
        const responseData = response instanceof HttpResponse ? response.body : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }

        if (status === 200 || status === 201) {
            // For JSON responses, the body is already parsed
            let result200: any = null;
            if (responseData) {
                result200 = responseData;
            }
            return _observableOf(result200);
        } else if (status === 400) {
            // For JSON responses, error data is already parsed
            let result400: any = null;
            if (responseData) {
                result400 = ProblemDetails.fromJS(responseData);
            }
            return throwException("A server side error occurred.", status, JSON.stringify(responseData), _headers, result400);
        } else if (status === 500) {
            return throwException("A server side error occurred.", status, JSON.stringify(responseData), _headers);
        } else if (status !== 200 && status !== 204) {
            return throwException("An unexpected server error occurred.", status, JSON.stringify(responseData), _headers);
        }
        return _observableOf(null as any);
    }

    getRates(request: GetQuoteRatesRequestModel): Observable<GetQuoteResponseModel> {
        let url_ = this.baseUrl + "/api/Quotes/rates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: any = {
            withCredentials: true,
            body: content_,

            //withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRates(response_, request);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuoteResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuoteResponseModel>;
        }));
    }

    protected processGetRates(response: HttpResponseBase, request?: GetQuoteRatesRequestModel): Observable<GetQuoteResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                const defaultValue = {
                    dependentsRate: 0,
                    ownerRate: 0,
                    rate: 0,
                    membersCount: 0,
                    appliesForOwner: false,
                    value: false
                }
                resultData200.maxCoverage = {
                    dependentsRate: resultData200.coverage.dependentsRate || 0,
                    ownerRate: resultData200.coverage.ownerRate || 0,
                    rate: resultData200.price || 0,
                    membersCount: 0,
                    appliesForOwner: false,
                    value: true
                }
                
                resultData200.number = request.number;
                resultData200.cancellationDueToCatastrophicTrip = defaultValue;
                resultData200.sportPractice = defaultValue;
                resultData200.preexistingMedicalConditions = defaultValue;
                resultData200.futureMom = defaultValue;
                resultData200.pets = defaultValue;
                resultData200.legalVipAssistance = defaultValue;
                resultData200.riderRates && resultData200.riderRates.map((riderRate: any) => {
                    const data = {
                        dependentsRate: riderRate.rateInfo.dependentsRate || 0,
                        ownerRate: riderRate.rateInfo.ownerRate || 0,
                        applicableDependentsCount: riderRate.rateInfo.dependentsCount || 0,
                        rate: riderRate.rateInfo.rate || 0,
                        membersCount: riderRate.rateInfo.membersCount || 0,
                        appliesForOwner: riderRate.rateInfo.ownerIncluded || false,
                        value: true
                    }
                    switch (riderRate.riderId) {
                        case 2:
                            resultData200.cancellationDueToCatastrophicTrip = data;
                            break;
                        case 3:
                            resultData200.sportPractice = data;
                            break;
                        case 4:
                            resultData200.preexistingMedicalConditions = data;
                            break;
                        // case 1:
                        //     resultData200.cancellationDueToCatastrophicTrip = data;
                        //     break;

                        case 6:
                            resultData200.futureMom = data;
                            break;

                        case 5:
                            resultData200.pets = data;
                            break;
                        case 7:
                            resultData200.legalVipAssistance = data;
                            break;
                    }
                })

                result200 = { ...resultData200 };

                return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putRates(request: GetQuoteRatesRequestModel): Observable<GetQuoteResponseModel> {
        let url_ = this.baseUrl + "/api/Quotes/" + request.number + "/rate";
        url_ = url_.replace(/[?&]$/, "");


        const content_ = JSON.stringify(request);

        let options_: any = {
            withCredentials: true,
            body: content_,

            //withCredentials: true,

            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,

            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuoteResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuoteResponseModel>;
        }));
    }

    createcertificate(quote: QuoteModel): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Quotes/${quote.number}/createcertificate`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            withCredentials: true,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };

        return this.http.request("post", url_, { ...options_ }).pipe(
            mergeMap((response_: any) => this.processCreateQuote(response_)),
            catchError((error_: any) => {
                if (error_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateQuote(error_ as any);
                    } catch (e) {
                        return throwError(e) as any as Observable<QuoteModel>;
                    }
                } else {
                    return throwError(error_) as any as Observable<QuoteModel>;
                }
            })
        );
    }

    createPendingActivationCertificate(policyQuoteNumber: string): Observable<QuoteModel> {
        let url_ = `${this.baseUrl}/api/Certificates/${policyQuoteNumber}/create`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            withCredentials: true,
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token,
            })
        };

        return this.http.request("post", url_, { ...options_ }).pipe(
            mergeMap((response_: any) => {
                return this.processCreateQuote(response_);
            }),
            catchError((error_: any) => {
                console.error('QuoteClient: Certificate creation error:', error_);
                if (error_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateQuote(error_ as any);
                    } catch (e) {
                        return throwError(e) as any as Observable<QuoteModel>;
                    }
                } else {
                    return throwError(error_) as any as Observable<QuoteModel>;
                }
            })
        );
    }

    private blobToText(blob: any): Observable<string> {
        return new Observable<string>((observer) => {
            if (!blob) {
                observer.next('');
                observer.complete();
            } else {
                const reader = new FileReader();
                reader.onload = () => {
                    observer.next(reader.result as string);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        });
    }

    getValidateCode(code: string): Observable<boolean> {
        let url_ = `${this.baseUrl}/api/Consultants/${encodeURIComponent(code)}/validate`;
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {

            withCredentials: true,

            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json", "Content-Type": "application/json", "Authorization": token,

            })
        };

        return this.http.request('get', url_, options_).pipe(
            switchMap((response: any) => this.blobToText(response.body)),
            map((text: string) => {
                return text ? JSON.parse(text) as boolean : false;
            })
        );
    }

}


// MP - added new models
export class ConfigurationModel {
    plans!: PlanModel[];
    premiumCalculationMethods!: PremiumCalculationMethodModel[];
    riders!: RiderModel[];

    constructor(data?: any) {
        if (data) {
            this.plans = data.plans ? data.plans.map((p: any) => PlanModel.fromJS(p)) : [];
            this.premiumCalculationMethods = data.premiumCalculationMethods ? data.premiumCalculationMethods.map((p: any) => PremiumCalculationMethodModel.fromJS(p)) : [];
            this.riders = data.riders ? data.riders.map((r: any) => RiderModel.fromJS(r)) : [];
        }
    }

    static fromJS(data: any): ConfigurationModel {
        return new ConfigurationModel(data);
    }

    toJSON(): any {
        return {
            plans: this.plans.map(p => p.toJSON()),
            premiumCalculationMethods: this.premiumCalculationMethods.map(p => p.toJSON()),
            riders: this.riders.map(r => r.toJSON())
        };
    }
}

export class PlanModel {
    id!: number;
    name!: string;
    maxCoverage!: number;

    constructor(data?: any) {
        if (data) {
            this.id = data.id;
            this.name = data.name;
            this.maxCoverage = data.maxCoverage;
        }
    }

    static fromJS(data: any): PlanModel {
        return new PlanModel(data);
    }

    toJSON(): any {
        return {
            id: this.id,
            name: this.name,
            maxCoverage: this.maxCoverage
        };
    }
}

export class PremiumCalculationMethodModel {
    id!: number;
    name!: string;

    constructor(data?: any) {
        if (data) {
            this.id = data.id;
            this.name = data.name;
        }
    }

    static fromJS(data: any): PremiumCalculationMethodModel {
        return new PremiumCalculationMethodModel(data);
    }

    toJSON(): any {
        return {
            id: this.id,
            name: this.name
        };
    }
}

export class RiderModel {
    id!: number;
    name!: string;
    premiumCalculationMethod!: number;
    options!: RiderOptionModel[];

    constructor(data?: any) {
        if (data) {
            this.id = data.id;
            this.name = data.name;
            this.premiumCalculationMethod = data.premiumCalculationMethod;
            this.options = data.options ? data.options.map((o: any) => RiderOptionModel.fromJS(o)) : [];
        }
    }

    static fromJS(data: any): RiderModel {
        return new RiderModel(data);
    }

    toJSON(): any {
        return {
            id: this.id,
            name: this.name,
            premiumCalculationMethod: this.premiumCalculationMethod,
            options: this.options.map(o => o.toJSON())
        };
    }
}

export class RiderOptionModel {
    name!: string;
    value!: any;

    constructor(data?: any) {
        if (data) {
            this.name = data.name;
            this.value = data.value;
        }
    }

    static fromJS(data: any): RiderOptionModel {
        return new RiderOptionModel(data);
    }

    toJSON(): any {
        return {
            name: this.name,
            value: this.value
        };
    }
}
export interface IRiderRates {
    riderId: number;
    value: string;
    rateInfo: {
        ownerIncluded: true,
        dependentsCount: number,
        rate: number,
        membersCount: number,
        ownerRate: number,
        dependentsRate: number
    }
}
export interface IQuoteRatesRequest {
    planId: number;
    riders: IRider[];
    tripStartDate: string;
    tripEndDate: string;
    dependentsCount: number;
    number?: number;
}

export interface IRider {
    riderId: number;
    value: string;
    memberDistribution: IMemberDistribution;
}

export interface IMemberDistribution {
    ownerIncluded: boolean;
    dependentsCount: number;
}
export interface IRateResponse {
    planId: number,
    riderRates: IRiderRates[]
}
export interface IQuoteModel {
    number?: string;
    agentCode?: string;
    residenceCountryId?: number;
    destinationRegionId?: number;
    tripStartDate?: string;
    tripEndDate?: string;
    applicantBirthdate?: string;
    dependentCount?: number;
    dependentCountOver65?: number;
    discountKey?: string;
    agreedReceivingOffers?: boolean;
    members?: MemberModel[];
    metadata?: MetadataModel[];
    rateResponse?: IRateResponse;
    rateRequest?: IQuoteRatesRequest;
}

export class QuoteModel implements IQuoteModel {
    number!: string;
    agentCode!: string;
    certificateNumber!: string;
    residenceCountry!: {
        id: number,
        name: string
    };
    residenceCountryId!: number;
    destinationRegion!: {
        id: number,
        name: string
    };
    destinationRegionId!: number;
    tripStartDate!: string;
    tripEndDate!: string;
    applicantBirthdate!: string;
    dependentCount!: number;
    dependentCountOver65!: number;
    discountKey?: string;
    agreedReceivingOffers!: boolean;
    members!: MemberModel[];
    metadata!: MetadataModel[];
    rateResponse?: IRateResponse;
    rateRequest?: IQuoteRatesRequest;

    constructor(data?: Partial<QuoteModel>) {
        if (data) {
            Object.assign(this, data);
            this.members = data.members?.map(m => new MemberModel(m)) || [];
            this.metadata = data.metadata?.map(m => new MetadataModel(m)) || [];
        }
    }

    // constructor(data?: IGetQuoteRatesRequestModel) {
    //     if (data) {
    //         for (var property in data) {
    //             if (data.hasOwnProperty(property))
    //                 (<any>this)[property] = (<any>data)[property];
    //         }
    //     }
    // }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.residenceCountryId = _data["residenceCountryId"];
            this.destinationRegionId = _data["destinationRegionId"];
            this.tripStartDate = _data["tripStartDate"] ? new Date(_data["tripStartDate"].toString()) : <any>undefined;
            this.tripEndDate = _data["tripEndDate"] ? new Date(_data["tripEndDate"].toString()) : <any>undefined;
            this.applicantBirthdate = _data["applicantBirthdate"] ? new Date(_data["applicantBirthdate"].toString()) : <any>undefined;
            this.dependentCount = _data["dependentCount"];
            this.dependentCountOver65 = _data["dependentCountOver65"];
            this.members = _data["members"] ? _data["members"].map((m: any) => MemberModel.fromJS(m)) : [];
            this.metadata = _data["metadata"] ? _data["metadata"].map((m: any) => MetadataModel.fromJS(m)) : [];
        }
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["residenceCountryId"] = this.residenceCountryId;
        data["destinationRegionId"] = this.destinationRegionId;
        data["tripStartDate"] = this.tripStartDate;
        data["tripEndDate"] = this.tripEndDate;
        data["applicantBirthdate"] = this.applicantBirthdate;
        data["dependentCount"] = this.dependentCount;
        data["dependentCountOver65"] = this.dependentCountOver65;
        data["members"] = this.members.map(m => m.toJSON());
        data["metadata"] = this.metadata ? this.metadata.map(m => m.toJSON()) : [];
        return data;
    }

    static fromJS(data: any): QuoteModel {
        return new QuoteModel({
            ...data,
            members: data.members?.map((m: any) => MemberModel.fromJS(m)) || [],
            metadata: data.metadata?.map((m: any) => MetadataModel.fromJS(m)) || []
        });
    }

    // toJSON(): any {
    //     return {
    //         ...this,
    //         members: this.members.map(m => m.toJSON()),
    //         metadata: this.metadata
    //     };
    // }
}

export class MemberModel {
    memberId!: number;
    memberType!: {
        id: number,
        name: string
    }
    memberTypeId!: number;
    firstName!: string;
    lastName!: string;
    email!: string;
    isDependent!: boolean;
    passportNumber!: string;
    relation!: string;
    countryId!: number;
    country!: {
        id: number,
        name: string
    }
    address!: AddressModel;
    phones!: PhoneModel[];
    birthdate!: string;

    constructor(data?: Partial<MemberModel>) {
        if (data) {
            Object.assign(this, data);
            this.address = new AddressModel(data.address);
            this.phones = data.phones?.map(p => new PhoneModel(p)) || [];
        }
    }

    static fromJS(data: any): MemberModel {
        return new MemberModel({
            ...data,
            address: AddressModel.fromJS(data.address),
            phones: data.phones?.map((p: any) => PhoneModel.fromJS(p)) || []
        });
    }

    toJSON(): any {
        return {
            ...this,
            address: this.address,
            phones: this.phones
        };
    }
}

export class AddressModel {
    address1!: string;
    address2!: string;
    address3!: string;
    city!: string;
    state!: string;
    postalCode!: string;

    constructor(data?: Partial<AddressModel>) {
        Object.assign(this, data);
    }

    static fromJS(data: any): AddressModel {
        return new AddressModel(data);
    }

    toJSON(): any {
        return { ...this };
    }
}

export class PhoneModel {
    countryCode!: string;
    phoneNumber!: string;
    phoneTypeId!: number;
    phoneType!: {
        id: number,
        name: string
    };

    constructor(data?: Partial<PhoneModel>) {
        Object.assign(this, data);
    }

    static fromJS(data: any): PhoneModel {
        return new PhoneModel(data);
    }

    toJSON(): any {
        return { ...this };
    }
}

export class MetadataModel {
    key!: string;
    value!: string;

    constructor(data?: Partial<MetadataModel>) {
        Object.assign(this, data);
    }

    static fromJS(data: any): MetadataModel {
        return new MetadataModel(data);
    }

    toJSON(): any {
        return { ...this };
    }
}
export class CountryModel implements ICountryModel {
    id!: number;
    code?: string | undefined;
    name?: string | undefined;
    regionId?: number | undefined;
    region?: GeographicalRegionModel | undefined;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.regionId = _data["regionId"];
            this.region = _data["region"] ? GeographicalRegionModel.fromJS(_data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["regionId"] = this.regionId;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICountryModel {
    id: number;
    code?: string | undefined;
    name?: string | undefined;
    regionId?: number | undefined;
    region?: GeographicalRegionModel | undefined;
}

export class GeographicalRegionModel implements IGeographicalRegionModel {
    id!: number;
    name?: string | undefined;

    constructor(data?: IGeographicalRegionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GeographicalRegionModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeographicalRegionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IGeographicalRegionModel {
    id: number;
    name?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class GetQuoteRatesRequestModel implements IQuoteRatesRequest {
    planId: number;
    riders: IRider[];
    tripStartDate: string;
    tripEndDate: string;
    dependentsCount: number;
    number?: number;
    static init: any;

    constructor(data?: IGetQuoteRatesRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripStartDate = _data["tripStartDate"] ? new Date(_data["tripStartDate"].toString()) : <any>undefined;
            this.tripEndDate = _data["tripEndDate"] ? new Date(_data["tripEndDate"].toString()) : <any>undefined;
            this.planId = _data["planId"];
            this.riders = _data["riders"];
            this.dependentsCount = _data["dependentCount"];
        }
    }

    static getRequest(_data?: any) {
        const data: any = {}
        if (_data) {
            data.number = _data["number"];
            data.tripStartDate = _data["tripStartDate"];
            data.tripEndDate = _data["tripEndDate"];
            data.planId = _data["planId"];
            data.riders = _data["riders"] || [];
            data.dependentsCount = _data["dependentCount"] + _data["dependentCountOver65"] || 0;
            const totalDependents = data.dependentsCount || 0;

            const buildRider = (riderId: number, value: any, ownerIncluded: boolean, dependentsCount: number) => {
                const hasOwner = !!ownerIncluded;
                const hasDependents = (dependentsCount || 0) > 0;
                const selected = hasOwner || hasDependents;

                if (!selected) {
                    return;
                }

                const normalizedValue =
                    typeof value === 'number'
                        ? value
                        : selected;
                if(riderId == 2) {
                    data.riders.push({
                        riderId,
                        value: value.toString(),
                        memberDistribution: {
                            ownerIncluded: true,
                            dependentsCount: 0
                        }
                    });
                } else if(riderId == 5) {
                    data.riders.push({
                        riderId,
                        value: value.toString(),
                        memberDistribution: {
                            ownerIncluded: true,
                            dependentsCount: 0
                        }
                    });
                } else if(riderId == 7) {
                    data.riders.push({
                        riderId,
                        value: normalizedValue.toString(),
                        memberDistribution: {
                            ownerIncluded: true,
                            dependentsCount: 0
                        }
                    });
                } else {
                    data.riders.push({
                        riderId,
                        value: normalizedValue.toString(),
                        memberDistribution: {
                            ownerIncluded: hasOwner,
                            dependentsCount: hasDependents ? dependentsCount : 0
                        }
                    });
                }
            };

            if (_data.cancellationDueToCatastrophicTrip && _data.cancellationDueToCatastrophicTrip.value > 0) {
                buildRider(
                    2,
                    _data.cancellationDueToCatastrophicTrip.value,
                    true,
                    0
                );
            }

            if (_data.sportPractice) {
                buildRider(
                    3,
                    _data.sportPractice.value,
                    _data.sportPractice.appliesForOwner || false,
                    _data.sportPractice.applicableDependentsCount || 0
                );
            }

            if (_data.preexistingMedicalConditions) {
                buildRider(
                    4,
                    _data.preexistingMedicalConditions.value,
                    _data.preexistingMedicalConditions.appliesForOwner || false,
                    _data.preexistingMedicalConditions.applicableDependentsCount || 0
                );
            }

            if (_data.futureMom) {
                buildRider(
                    6,
                    _data.futureMom.value,
                    _data.futureMom.appliesForOwner || false,
                    _data.futureMom.applicableDependentsCount || 0
                );
            }

            if (_data.pets && _data.pets.value > 0) {
                buildRider(
                    5,
                    _data.pets.value,
                    true,
                    0
                );
            }

            if (_data.legalVipAssistance && _data.legalVipAssistance.value) {
                buildRider(
                    7,
                    _data.legalVipAssistance.value,
                    true,
                    0
                );
            }
        }
        
        return data;
    }

    static fromJS(data: any): GetQuoteRatesRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuoteRatesRequestModel();
        result.init(data);
        return result;
    }



    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripStartDate"] = this.tripStartDate
        data["tripEndDate"] = this.tripEndDate;
        data["planId"] = this.planId;
        data["riders"] = this.riders;
        data["dependentsCount"] = this.dependentsCount;
        return data;
    }
}

export interface IGetQuoteRatesRequestModel {
    number?: string;
    residenceCountryId: number;
    geographicalDestinationId: number;
    tripStartDate: Date;
    tripEndDate: Date;
    applicantBirthdate: Date;
    dependentCount: number;
    dependentCountOver65: number;
    applicantName?: string | undefined;
    applicantLastName?: string | undefined;
    applicantEmail?: string | undefined;
    applicantPhone?: string | undefined;
    applicantPhoneCode?: string | undefined;
    planId: number;
    maxCoverage?: DecimalOptionalBenefitRate | undefined;
    cancellationDueToCatastrophicTrip?: DecimalOptionalBenefitRate | undefined;
    sportPractice?: BooleanOptionalBenefitRate | undefined;
    preexistingMedicalConditions?: BooleanOptionalBenefitRate | undefined;
    pets?: IntOptionalBenefitRate | undefined;
    futureMom?: BooleanOptionalBenefitRate | undefined;
    legalVipAssistance?: BooleanOptionalBenefitRate | undefined;
    quoteDetails?: QuoteModel | undefined;
    price?: number
}

export class GetQuoteResponseModel extends QuoteModel implements IQuoteModel {
    adminFee?: number | undefined;
    durationInDays!: number;
    price!: number;

    constructor(data?: IQuoteModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.adminFee = _data["adminFee"];
            this.durationInDays = _data["durationInDays"];
            this.price = _data["price"];
        }
    }



    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminFee"] = this.adminFee;
        data["durationInDays"] = this.durationInDays;
        data["price"] = this.price;
        super.toJSON();
        return data;
    }
}

export interface IGetQuoteRatesResponseModel extends IGetQuoteRatesRequestModel {
    adminFee?: number | undefined;
    durationInDays: number;
    price: number;
}

export class QuoteRateView implements IGetQuoteRatesRequestModel {
    number?: string;
    residenceCountryId: number;
    geographicalDestinationId: number;
    tripStartDate: Date;
    tripEndDate: Date;
    applicantBirthdate: Date;
    dependentCount: number;
    dependentCountOver65: number;
    applicantName?: string;
    applicantLastName?: string;
    applicantEmail?: string;
    applicantPhone?: string;
    applicantPhoneCode?: string;
    planId: number;
    maxCoverage?: DecimalOptionalBenefitRate;
    cancellationDueToCatastrophicTrip?: DecimalOptionalBenefitRate;
    sportPractice?: BooleanOptionalBenefitRate;
    preexistingMedicalConditions?: BooleanOptionalBenefitRate;
    pets?: IntOptionalBenefitRate;
    futureMom?: BooleanOptionalBenefitRate;
    legalVipAssistance?: BooleanOptionalBenefitRate;
    price?: number;

    constructor(data?: IGetQuoteRatesRequestModel) {
        this.cancellationDueToCatastrophicTrip = new DecimalOptionalBenefitRate()
        this.sportPractice = new BooleanOptionalBenefitRate();
        this.preexistingMedicalConditions = new BooleanOptionalBenefitRate();
        this.pets = new IntOptionalBenefitRate();
        this.futureMom = new BooleanOptionalBenefitRate();
        this.legalVipAssistance = new BooleanOptionalBenefitRate();
        this.price = 0
    }
    init(_data?: any) {
        if (_data) {
            this.residenceCountryId = _data["residenceCountryId"];
            this.geographicalDestinationId = _data["geographicalDestinationId"];
            this.tripStartDate = _data["tripStartDate"] ? new Date(_data["tripStartDate"].toString()) : <any>undefined;
            this.tripEndDate = _data["tripEndDate"] ? new Date(_data["tripEndDate"].toString()) : <any>undefined;
            this.applicantBirthdate = _data["applicantBirthdate"] ? new Date(_data["applicantBirthdate"].toString()) : <any>undefined;
            this.dependentCount = _data["dependentCount"];
            this.dependentCountOver65 = _data["dependentCountOver65"];
            this.applicantName = _data["applicantName"];
            this.applicantLastName = _data["applicantLastName"];
            this.applicantEmail = _data["applicantEmail"];
            this.applicantPhone = _data["applicantPhone"];
            this.planId = _data["planId"];
            this.maxCoverage = _data["maxCoverage"] ? DecimalOptionalBenefitRate.fromJS(_data["maxCoverage"]) : <any>undefined;
            this.cancellationDueToCatastrophicTrip = _data["cancellationDueToCatastrophicTrip"] ? DecimalOptionalBenefitRate.fromJS(_data["cancellationDueToCatastrophicTrip"]) : <any>undefined;
            this.sportPractice = _data["sportPractice"] ? BooleanOptionalBenefitRate.fromJS(_data["sportPractice"]) : <any>undefined;
            this.preexistingMedicalConditions = _data["preexistingMedicalConditions"] ? BooleanOptionalBenefitRate.fromJS(_data["preexistingMedicalConditions"]) : <any>undefined;
            this.pets = _data["pets"] ? IntOptionalBenefitRate.fromJS(_data["pets"]) : <any>undefined;
            this.futureMom = _data["futureMom"] ? BooleanOptionalBenefitRate.fromJS(_data["futureMom"]) : <any>undefined;
            this.legalVipAssistance = _data["legalVipAssistance"] ? BooleanOptionalBenefitRate.fromJS(_data["legalVipAssistance"]) : <any>undefined;
        }
    }

    static convertToPlanRatesRequest(data, tripStartDate, tripEndDate) {
        const planRatesRequest = {
            planId: data.planId,
            riders: [],
            tripStartDate: tripStartDate.replace(/T.*/, ''),
            tripEndDate: tripEndDate.replace(/T.*/, ''),
            dependentsCount: data.dependentCount
        };

        const riders: any[] = [];
        const totalDependents = data.dependentCount || 0;

        const buildRider = (riderId: number, value: any, ownerIncluded: boolean, dependentsCount: number) => {
            const hasOwner = !!ownerIncluded;
            const hasDependents = (dependentsCount || 0) > 0;
            const selected = hasOwner || hasDependents;

            if (!selected) {
                return;
            }

            const normalizedValue =
                typeof value === 'number'
                    ? value
                    : selected;

            riders.push({
                riderId,
                value: normalizedValue.toString(),
                memberDistribution: {
                    ownerIncluded: hasOwner,
                    dependentsCount: hasDependents ? dependentsCount : 0
                }
            });
        };

        if (data.cancellationDueToCatastrophicTrip && data.cancellationDueToCatastrophicTrip.value > 0) {
            buildRider(
                2,
                data.cancellationDueToCatastrophicTrip.value,
                data.cancellationDueToCatastrophicTrip.appliesForOwner,
                totalDependents
            );
        }

        if (data.sportPractice) {
            buildRider(
                3,
                data.sportPractice.value,
                data.sportPractice.appliesForOwner,
                data.sportPractice.applicableDependentsCount || 0
            );
        }

        if (data.preexistingMedicalConditions) {
            buildRider(
                4,
                data.preexistingMedicalConditions.value,
                data.preexistingMedicalConditions.appliesForOwner,
                data.preexistingMedicalConditions.applicableDependentsCount || 0
            );
        }

        if (data.futureMom) {
            buildRider(
                6,
                data.futureMom.value,
                data.futureMom.appliesForOwner,
                data.futureMom.applicableDependentsCount || 0
            );
        }

        if (data.pets && data.pets.value > 0) {
            buildRider(
                5,
                data.pets.value,
                data.pets.appliesForOwner,
                totalDependents
            );
        }

        if (data.legalVipAssistance && data.legalVipAssistance.value) {
            buildRider(
                7,
                data.legalVipAssistance.value,
                data.legalVipAssistance.appliesForOwner,
                totalDependents
            );
        }

        planRatesRequest.riders = riders;

        return planRatesRequest;
    }

}

export abstract class OptionalBenefitRate implements IOptionalBenefitRate {
    rate?: number | undefined;
    appliesForOwner?: boolean | undefined;
    applicableDependentsCount?: number | undefined;
    membersCount?: number | undefined;
    ownerRate?: number | undefined;
    dependentsRate?: number | undefined;

    constructor(data?: IOptionalBenefitRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.appliesForOwner = _data["appliesForOwner"];
            this.applicableDependentsCount = _data["applicableDependentsCount"];
            this.membersCount = _data["membersCount"];
            this.ownerRate = _data["ownerRate"];
            this.dependentsRate = _data["dependentsRate"];
        }
    }

    static fromJS(data: any): OptionalBenefitRate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'OptionalBenefitRate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["appliesForOwner"] = this.appliesForOwner;
        data["applicableDependentsCount"] = this.applicableDependentsCount;
        data["membersCount"] = this.membersCount;
        data["ownerRate"] = this.ownerRate;
        data["dependentsRate"] = this.dependentsRate;
        return data;
    }
}

export interface IOptionalBenefitRate {
    rate?: number | undefined;
    appliesForOwner?: boolean | undefined;
    applicableDependentsCount?: number | undefined;
    membersCount?: number | undefined;
    ownerRate?: number | undefined;
    dependentsRate?: number | undefined;
}

export class DecimalOptionalBenefitRate extends OptionalBenefitRate implements IDecimalOptionalBenefitRate {
    value!: number;

    constructor(data?: IDecimalOptionalBenefitRate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): DecimalOptionalBenefitRate {
        data = typeof data === 'object' ? data : {};
        let result = new DecimalOptionalBenefitRate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IDecimalOptionalBenefitRate extends IOptionalBenefitRate {
    value: number;
}

export class BooleanOptionalBenefitRate extends OptionalBenefitRate implements IBooleanOptionalBenefitRate {
    value!: boolean;

    constructor(data?: IBooleanOptionalBenefitRate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BooleanOptionalBenefitRate {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanOptionalBenefitRate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanOptionalBenefitRate extends IOptionalBenefitRate {
    value: boolean;
}

export class IntOptionalBenefitRate extends OptionalBenefitRate implements IIntOptionalBenefitRate {
    value!: number;

    constructor(data?: IIntOptionalBenefitRate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): IntOptionalBenefitRate {
        data = typeof data === 'object' ? data : {};
        let result = new IntOptionalBenefitRate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IIntOptionalBenefitRate extends IOptionalBenefitRate {
    value: number;
}

export class AgentInvitationRequestModel implements IAgentInvitationRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IAgentInvitationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): AgentInvitationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentInvitationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["country"] = this.country;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IAgentInvitationRequestModel {
    fullName?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    phone?: string | undefined;
}

export class SendQuoteByEmailModel implements ISendQuoteByEmailModel {
    quoteModel?: GetQuoteResponseModel | undefined;
    recipientEmails?: string | undefined;

    constructor(data?: ISendQuoteByEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteModel = _data["quoteModel"] ? GetQuoteResponseModel.fromJS(_data["quoteModel"]) : <any>undefined;
            this.recipientEmails = _data["recipientEmails"];
        }
    }

    static fromJS(data: any): SendQuoteByEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendQuoteByEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};

        let model: GetQuoteResponseModel = null;
        if (this.quoteModel) {
            const json = JSON.stringify(this.quoteModel);
            model = JSON.parse(json);
        }

        //data["quoteModel"] = this.quoteModel ? this.quoteModel.toJSON() : <any>undefined;
        data["quoteModel"] = model ? model : <any>undefined;
        data["recipientEmails"] = this.recipientEmails;
        return data;
    }
}

export interface ISendQuoteByEmailModel {
    quoteModel?: GetQuoteResponseModel | undefined;
    recipientEmails?: string | undefined;
}

export class PaymentProcessorResponseModel implements IPaymentProcessorResponseModel {
    isSuccess!: boolean;
    authorizationNumber?: string | undefined;
    transactionId?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    token?: string | undefined;

    constructor(data?: IPaymentProcessorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.authorizationNumber = _data["authorizationNumber"];
            this.transactionId = _data["transactionId"];
            this.responseCode = _data["responseCode"];
            this.responseDescription = _data["responseDescription"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): PaymentProcessorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProcessorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["authorizationNumber"] = this.authorizationNumber;
        data["transactionId"] = this.transactionId;
        data["responseCode"] = this.responseCode;
        data["responseDescription"] = this.responseDescription;
        data["token"] = this.token;
        return data;
    }
}

export interface IPaymentProcessorResponseModel {
    isSuccess: boolean;
    authorizationNumber?: string | undefined;
    transactionId?: string | undefined;
    responseCode?: string | undefined;
    responseDescription?: string | undefined;
    token?: string | undefined;
}

export abstract class PaymentRequestModel implements IPaymentRequestModel {
    invoiceNumber?: string | undefined;
    amount!: number;

    constructor(data?: IPaymentRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): PaymentRequestModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PaymentRequestModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IPaymentRequestModel {
    invoiceNumber?: string | undefined;
    amount: number;
}

export class CardPaymentRequestModel extends PaymentRequestModel implements ICardPaymentRequestModel {
    payer: {
        firstName: string;
        lastName: string;
        phone: {
            countryCode: string;
            phoneNumber: string;
            phoneTypeId: number
        },
        email: string;
    }
    card: {
        cardholderName: string;
        cardNumber: string;
        expirationMonth: number;
        expirationYear: number;
        cvv: string;
    }
    cardholderName?: string | undefined;
    cardNumber?: string | undefined;
    expirationMonth!: number;
    expirationYear!: number;
    cvv?: string | undefined;
    token?: string | undefined;
    number?: string | undefined;

    constructor(data?: ICardPaymentRequestModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.cardholderName = _data["cardholderName"];
            this.cardNumber = _data["cardNumber"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.cvv = _data["cvv"];
            this.token = _data["token"];
            this.number = _data["number"];
            this.payer = _data["payer"];
            this.card = _data["card"];
        }
    }

    static override fromJS(data: any): CardPaymentRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CardPaymentRequestModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardholderName"] = this.cardholderName;
        data["cardNumber"] = this.cardNumber;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["cvv"] = this.cvv;
        data["token"] = this.token;
        super.toJSON(data);
        return data;
    }
}

export interface ICardPaymentRequestModel extends IPaymentRequestModel {
    cardholderName?: string | undefined;
    cardNumber?: string | undefined;
    expirationMonth: number;
    expirationYear: number;
    cvv?: string | undefined;
    token?: string | undefined;
    payer?: {
        firstName: string;
        lastName: string;
        phone: {
            countryCode: string;
            phoneNumber: string;
            phoneTypeId: number
        },
        email: string;
    }
    card?: {
        cardholderName: string;
        cardNumber: string;
        expirationMonth: number;
        expirationYear: number;
        cvv: string;
    }
    number?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
